import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function LandingPage({ user }: { user: any }) {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const L = (key: string) => t(`landing.${key}`)

  const lang = i18n.language?.split('-')[0] || 'en'
  if (typeof document !== 'undefined') {
    const titles: Record<string, string> = { it: 'Study Planner Schedule — Piano di Studio Universitario', en: 'Study Planner Schedule — University Study Planner', de: 'Study Planner Schedule — Lernplaner', fr: 'Study Planner Schedule — Planificateur d\'etudes', es: 'Study Planner Schedule — Planificador de estudios', pt: 'Study Planner Schedule — Planejador de estudos' }
    const descs: Record<string, string> = { it: 'Crea il tuo piano di studio in 2 minuti. Gratis.', en: 'Create your study plan in 2 minutes. Free forever.', de: 'Erstelle deinen Lernplan in 2 Minuten. Kostenlos.', fr: 'Creez votre plan en 2 minutes. Gratuit.', es: 'Crea tu plan en 2 minutos. Gratis.', pt: 'Crie seu plano em 2 minutos. Gratis.' }
    document.title = titles[lang] || titles['en']
    const d = document.querySelector('meta[name="description"]'); if (d) d.setAttribute('content', descs[lang] || descs['en'])
  }

  const goToApp = () => {
    if (user) navigate('/app')
    else navigate('/auth')
  }

  const goToPremium = () => {
    if (user) {
      localStorage.setItem('open_premium_after_login', '1')
      navigate('/app')
    } else {
      localStorage.setItem('open_premium_after_login', '1')
      navigate('/auth?next=premium')
    }
  }

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', color: '#111827' }}>

      {/* NAVBAR */}
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid #E5E7EB', background: 'white', position: 'sticky', top: 0, zIndex: 10, gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 15, fontWeight: 600 }}>
          <img src='/logo.png' alt='' style={{ width: 36, height: 36, borderRadius: 8, objectFit: 'cover', flexShrink: 0, display: window.innerWidth > 600 ? 'block' : 'none' } as any} />
          <span style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>Study Planner Schedule</span>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          {user ? (
            <button onClick={() => navigate('/app')} style={{ background: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              Vai all'app
            </button>
          ) : (
            <>
              <button onClick={() => navigate('/auth')} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
                {L('nav_login')}
              </button>
              <button onClick={goToApp} style={{ background: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
                {L('nav_cta')}
              </button>
            </>
          )}
        </div>
      </nav>

      {/* HERO */}
      <section style={{ padding: '40px 20px 40px', textAlign: 'center', maxWidth: 680, margin: '0 auto' }}>
        <img src='/logo.png' alt='Study Planner Schedule' style={{ width: 130, height: 130, borderRadius: 28, objectFit: 'cover', marginBottom: 20 }} />
        <h1 style={{ fontSize: 'clamp(26px, 6vw, 40px)', fontWeight: 700, lineHeight: 1.2, marginBottom: 20 }}>
          {L('hero_title1')}<br />
          <span style={{ color: '#1c3fff' }}>{L('hero_title2')}</span> {L('hero_title3')}
        </h1>
        <p style={{ fontSize: 17, color: '#6B7280', lineHeight: 1.7, marginBottom: 36, maxWidth: 520, margin: '0 auto 36px' }}>
          {L('hero_sub')}
        </p>
        <button onClick={goToApp} style={{ background: '#1c3fff', color: 'white', border: 'none', borderRadius: 12, padding: '16px 36px', fontSize: 16, fontWeight: 700, cursor: 'pointer', marginBottom: 32 }}>
          {L('hero_cta')} →
        </button>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontSize: 13, color: '#9CA3AF' }}>
          <div style={{ display: 'flex' }}>
            {['A','M','G','L'].map((l, i) => (
              <div key={i} style={{ width: 26, height: 26, borderRadius: '50%', background: '#1c3fff', border: '2px solid white', marginLeft: i === 0 ? 0 : -6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: 'white', fontWeight: 600 }}>{l}</div>
            ))}
          </div>
          {L('social_proof')}
        </div>
      </section>

      <p style={{ textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#1c3fff', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>{L('how_label')}</p>
      <section id="come-funziona" style={{ padding: '48px 20px', background: '#F8F9FA' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, marginBottom: 48 }}>{L('how_title')}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, maxWidth: 680, margin: '0 auto' }}>
          {[
            { n: '1', title: L('step1_title'), desc: L('step1_desc') },
            { n: '2', title: L('step2_title'), desc: L('step2_desc') },
            { n: '3', title: L('step3_title'), desc: L('step3_desc') },
          ].map(s => (
            <div key={s.n} style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: 16, padding: '28px 20px', textAlign: 'center' }}>
              <div style={{ width: 36, height: 36, background: '#1c3fff', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, margin: '0 auto 16px' }}>{s.n}</div>
              <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>{s.title}</h3>
              <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURES */}
      <section style={{ padding: '48px 20px', maxWidth: 680, margin: '0 auto' }}>
        <p style={{ textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#1c3fff', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>{L('feat_label')}</p>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, marginBottom: 48 }}>{L('feat_title')}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
          {[
            { icon: '📅', bg: '#E6F1FB', title: L('feat1_title'), desc: L('feat1_desc') },
            { icon: '✅', bg: '#E1F5EE', title: L('feat2_title'), desc: L('feat2_desc') },
            { icon: '📄', bg: '#FAEEDA', title: L('feat3_title'), desc: L('feat3_desc') },
            { icon: '📆', bg: '#FAECE7', title: L('feat4_title'), desc: L('feat4_desc') },
          ].map(f => (
            <div key={f.title} style={{ display: 'flex', gap: 16, padding: 20, border: '1px solid #E5E7EB', borderRadius: 16, background: 'white' }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: f.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>{f.icon}</div>
              <div>
                <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 5 }}>{f.title}</h3>
                <p style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.5 }}>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <p style={{ textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#1c3fff', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>{L('pricing_label')}</p>
      <section id="prezzi" style={{ padding: '48px 20px', background: '#F8F9FA' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, marginBottom: 48 }}>{L('pricing_title')}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, maxWidth: 720, margin: '0 auto' }}>
          <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: 16, padding: '28px 24px' }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{L('free_name')}</h3>
            <div style={{ fontSize: 32, fontWeight: 700, margin: '14px 0 4px' }}>€0 <span style={{ fontSize: 14, color: '#9CA3AF', fontWeight: 400 }}>{L('free_period')}</span></div>
            <ul style={{ listStyle: 'none', margin: '16px 0 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[L('free_feat1'), L('free_feat2'), L('free_feat3')].map(item => (
                <li key={item} style={{ fontSize: 13, color: '#6B7280', display: 'flex', gap: 8 }}><span style={{ color: '#1c3fff' }}>✓</span>{item}</li>
              ))}
            </ul>
            <button onClick={goToApp} style={{ width: '100%', padding: 11, borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', background: '#F3F4F6', border: '1px solid #E5E7EB', color: '#111827' }}>{L('free_cta')}</button>
          </div>
          <div style={{ background: 'white', border: '2px solid #1c3fff', borderRadius: 16, padding: '28px 24px' }}>
            <div style={{ background: '#E6F1FB', color: '#0C447C', fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20, display: 'inline-block', marginBottom: 14 }}>{L('monthly_badge')}</div>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{L('monthly_name')}</h3>
            <div style={{ fontSize: 32, fontWeight: 700, margin: '14px 0 4px' }}>€2.99 <span style={{ fontSize: 14, color: '#9CA3AF', fontWeight: 400 }}>{L('monthly_period')}</span></div>
            <ul style={{ listStyle: 'none', margin: '16px 0 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[L('premium_feat1'), L('premium_feat2'), L('premium_feat3')].map(item => (
                <li key={item} style={{ fontSize: 13, color: '#6B7280', display: 'flex', gap: 8 }}><span style={{ color: '#1c3fff' }}>✓</span>{item}</li>
              ))}
            </ul>
            <button onClick={goToPremium} style={{ width: '100%', padding: 11, borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', background: '#1c3fff', border: 'none', color: 'white' }}>{L('monthly_cta')}</button>
          </div>
          <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: 16, padding: '28px 24px' }}>
            <div style={{ background: '#E1F5EE', color: '#0F6E56', fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20, display: 'inline-block', marginBottom: 14 }}>{L('annual_badge')}</div>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{L('annual_name')}</h3>
            <div style={{ fontSize: 32, fontWeight: 700, margin: '14px 0 4px' }}>€27.99 <span style={{ fontSize: 14, color: '#9CA3AF', fontWeight: 400 }}>{L('annual_period')}</span></div>
            <div style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 8 }}>€2.33{L('monthly_period')}</div>
            <ul style={{ listStyle: 'none', margin: '16px 0 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[L('premium_feat1'), L('premium_feat2'), L('premium_feat3')].map(item => (
                <li key={item} style={{ fontSize: 13, color: '#6B7280', display: 'flex', gap: 8 }}><span style={{ color: '#1c3fff' }}>✓</span>{item}</li>
              ))}
            </ul>
            <button onClick={goToPremium} style={{ width: '100%', padding: 11, borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', background: '#F3F4F6', border: '1px solid #E5E7EB', color: '#111827' }}>{L('annual_cta')}</button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '48px 20px', textAlign: 'center', background: '#1c3fff' }}>
        <h2 style={{ fontSize: 30, fontWeight: 700, color: 'white', marginBottom: 12 }}>{L('cta_title')}</h2>
        <p style={{ color: 'rgba(255,255,255,0.75)', marginBottom: 28, fontSize: 15 }}>{L('cta_sub')}</p>
        <button onClick={goToApp} style={{ background: 'white', color: '#1c3fff', border: 'none', borderRadius: 12, padding: '16px 36px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
          {L('hero_cta')} →
        </button>
      </section>

      {/* FOOTER */}
      <footer style={{ padding: '32px', borderTop: '1px solid #E5E7EB', background: 'white' }}>
        <div style={{ maxWidth: 680, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
  
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', width: '100%' }}>
            <a href="https://www.instagram.com/study.planner.schedule" target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#9CA3AF', textDecoration: 'none' }}>Instagram</a>
            <a href="https://www.tiktok.com/@study.planner.schedule" target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#9CA3AF', textDecoration: 'none' }}>TikTok</a>
            <a href="https://youtube.com/@studyplannerschedule" target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#9CA3AF', textDecoration: 'none' }}>YouTube</a>
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <a href="/privacy" style={{ fontSize: 13, color: '#9CA3AF', textDecoration: 'none' }}>Privacy Policy</a>
            <a href="#" style={{ fontSize: 13, color: '#9CA3AF', textDecoration: 'none' }}>Terms of Service</a>
          </div>
        </div>
        <p style={{ textAlign: 'center', fontSize: 12, color: '#D1D5DB', marginTop: 20 }}>© 2026 Study Planner Schedule</p>
      </footer>

    </div>
  )
}
